import axiosInstance from '@/services/api/axios';
import type {
  Loss,
  LossListResponse,
  LossPayload,
  ResponsibleUser,
} from '@/types/loss';

type LossFilters = {
  q?: string;
  responsible_user_id?: string;
  is_money_lost?: boolean;
  transaction_id?: string;
  occurred_from?: string;
  occurred_to?: string;
  limit?: number;
  offset?: number;
};

export const lossesService = {
  list: async (filters: LossFilters): Promise<LossListResponse> =>
    (await axiosInstance.get('/losses', { params: filters })).data,

  responsibleUsers: async (q = ''): Promise<ResponsibleUser[]> =>
    (await axiosInstance.get('/losses/responsible-users', { params: { q, limit: 50 } })).data,

  create: async (payload: LossPayload): Promise<Loss> =>
    (await axiosInstance.post('/losses', payload)).data,

  update: async (lossId: string, payload: LossPayload): Promise<Loss> =>
    (await axiosInstance.put(`/losses/${lossId}`, payload)).data,
};
